import styled from 'styled-components';
import { Button } from '@hulu/react-style-components';
import React from 'react';
import { Form } from 'antd';

export const Y_SCROLL = { y: '50vh' };

const StyledBtn = styled(Button)`
  min-width: 150px;
  height: 35px;
  max-width: 200px;
  display: block;
  margin: 0;
  margin-bottom: 15px;
  margin-top: 15px;
  text-align: center;
`;
export const ButtonWrapper = ({ children, ...rest }) => <StyledBtn {...rest}>{children}</StyledBtn>;

export const PermissionManagerWrapper = styled.div`
  justify-content: space-between;
  padding: 30px 50px;
  gap: 20px;
`;

export const FormWrapper = ({ children, ...rest }) => <PaddedForm {...rest}>{children}</PaddedForm>;

export const PaddedForm = styled(Form)`
  padding: 5px 20px;
  border: 5px solid #d9d9d9;
  border-radius: 4px;
  margin-left: 80px;
`;
